import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metro-sys",
  "use": "icon-metro-sys-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-metro-sys\"><path d=\"M896 789.333333H0V853.333333h896a32 32 0 0 0 0-64z m54.912-320H640V341.333333h150.698667C674.986667 269.482667 529.066667 213.333333 384 213.333333H0v512h896.597333C966.485333 725.333333 1024 711.893333 1024 597.461333c0-33.152-27.008-79.274667-73.088-128.128zM256 469.333333H128V341.333333h128v128z m256 0H384V341.333333h128v128z\" p-id=\"22608\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol